import React from "react";
import { QuestionMarkCircleIcon } from "@heroicons/react/24/outline";
import ReactTooltip from "react-tooltip";

type Props = {
  text: string;
  tooltipText: string;
};

const SummaryHeaderQuestionMarkTitle = ({ text, tooltipText }: Props) => {
  return (
    <div className="print:text-xs print:mb-0 text-lg font-bold mb-4 flex items-center justify-center gap-2">
      {text}
      <span>
        <QuestionMarkCircleIcon
          className="w-6 h-6 text-orange-500"
          data-tip={tooltipText}
        />
      </span>
      <ReactTooltip
        html={true}
        className="hover:visible:opacity-1 w-96"
        delayHide={166}
        effect="solid"
      />
    </div>
  );
};

export default SummaryHeaderQuestionMarkTitle;
